import { render, staticRenderFns } from "./ListStyleControl.vue?vue&type=template&id=15651a61&scoped=true"
import script from "./ListStyleControl.vue?vue&type=script&lang=js"
export * from "./ListStyleControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15651a61",
  null
  
)

export default component.exports